import { render } from "./RegistOneClassAdult.vue?vue&type=template&id=6301374e&scoped=true"
import script from "./RegistOneClassAdult.vue?vue&type=script&lang=js"
export * from "./RegistOneClassAdult.vue?vue&type=script&lang=js"

import "./RegistOneClassAdult.vue?vue&type=style&index=0&id=6301374e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6301374e"]])

export default __exports__